$.SetCookie = (name, value, ttl) => {};

$.Consent = (name, essential, functional, performance, targeting) => {
    if (name.trim() === "") return;

    const date = new Date();
    date.setTime(date.getTime() + 60 * 60 * 24 * 50 * 1000);
    const expires = `; expires=${date.toUTCString()}`;

    document.cookie = `${name}=${JSON.stringify({
        essential,
        functional,
        performance,
        targeting,
    })}${expires}; path=/`;
};

$(document).ready(function () {
    if ($("#consentModal").length && $("#consentDetailsModal").length) {
        const m = new bootstrap.Modal($("#consentModal"));
        const dm = new bootstrap.Modal($("#consentDetailsModal"));

        $("#consentAcceptAll").on("click", () => {
            $.Consent(window.requestedConsent, true, true, true, true);
            window.location.reload();
        });
        $("#consentRejectAll").on("click", () => {
            $.Consent(window.requestedConsent, false, false, false, false);
            window.location.reload();
        });
        $("#consentDetails").on("click", () => {
            m.hide();
            dm.show();
        });

        $("#consentSaveSettings").on("click", () => {
            const functional = $("#functionalConsent").is(":checked");
            const performance = $("#performanceConsent").is(":checked");
            const targeting = $("#targetingConsent").is(":checked");

            $.Consent(
                window.requestedConsent,
                true,
                functional,
                performance,
                targeting
            );
            window.location.reload();
        });

        if (window.requestConsent === true) m.show();
    }
});
